import { useState, useEffect } from "react";

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ date }) => {
  const [t, setT] = useState({ d: 0, h: 0, m: 0, s: 0 });

  useEffect(() => {
    const target = new Date(date).getTime();
    const tick = () => {
      const diff = Math.max(0, target - Date.now());
      setT({
        d: Math.floor(diff / 86400000),
        h: Math.floor((diff % 86400000) / 3600000),
        m: Math.floor((diff % 3600000) / 60000),
        s: Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [date]);

  const items = [
    { label: "Days", val: t.d, key: "days" },
    { label: "Hours", val: pad(t.h), key: "hours" },
    { label: "Minutes", val: pad(t.m), key: "minutes" },
    { label: "Seconds", val: pad(t.s), key: "seconds" },
  ];

  return (
    <div className="flex items-center justify-center gap-4 sm:gap-8" data-testid="hero-countdown">
      {items.map((it) => (
        <div key={it.key} className="text-center" data-testid={`hero-countdown-${it.key}`}>
          <div className="font-serif text-3xl sm:text-5xl font-light text-white tabular-nums">
            {it.val}
          </div>
          <div className="mt-1 text-[10px] sm:text-xs uppercase tracking-[0.25em] text-white/70">
            {it.label}
          </div>
        </div>
      ))}
    </div>
  );
};
